import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import PageHero from '@/components/feature/PageHero';
import ContactStrip from '@/components/feature/ContactStrip';

const services = [
  {
    icon: 'ri-key-2-line',
    title: 'Leasing & Bookings',
    desc: 'Long-term leasing and short-term rental bookings for residential property owned by the company and its principals.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Tenant & Guest Relations',
    desc: 'Day-to-day communication and support for tenants and guests.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Repairs & Preventive Maintenance',
    desc: 'Ongoing repairs and preventive maintenance to keep properties in good order.',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Small Project Management',
    desc: 'Renovations, unit refreshes, and capital improvements.',
  },
  {
    icon: 'ri-government-line',
    title: 'Property Tax & Transient Occupancy Tax',
    desc: 'Handling property tax and transient occupancy tax for the properties we manage.',
  },
];

export default function Properties() {
  return (
    <main className="min-h-screen">
      <SiteHeader />
      <PageHero
        eyebrow="A Division of Penland LLC"
        title="Penland"
        titleAccent="Properties"
        subtitle="We manage long-term and short-term residential rental property owned by the company and its principals."
        image="https://readdy.ai/api/search-image?query=Stylized%20minimal%20residential%20architecture%20facade%20with%20clean%20lines%20and%20warm%20neutral%20tones%2C%20soft%20dusk%20lighting%2C%20elegant%20architectural%20editorial%20photography%2C%20subtle%20depth%20and%20calm%20atmosphere&width=1600&height=900&seq=properties-hero-01&orientation=landscape"
        imageAlt="Minimal residential architecture representing Penland Properties"
        cta={{ label: 'Contact Property Management', href: '#contact' }}
      />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <div className="mb-12 md:mb-16">
              <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
                What We Handle
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 max-w-3xl leading-tight">
                Residential property,
                <span className="italic text-accent-600"> fully managed</span>
              </h2>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
              {services.map((svc, i) => (
                <div
                  key={i}
                  className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/60 hover:border-accent-300/40 hover:-translate-y-1 transition-all flex flex-col"
                >
                  <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                    <i className={`${svc.icon} text-accent-600 text-2xl`} />
                  </div>
                  <h3 className="font-heading text-lg md:text-xl text-primary-950 font-semibold mb-3">
                    {svc.title}
                  </h3>
                  <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                    {svc.desc}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-10 md:mt-12 bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-8 flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center shrink-0">
                <i className="ri-information-line text-secondary-700 text-2xl" />
              </div>
              <p className="text-foreground-600 text-base leading-relaxed">
                Maintenance and small project management are also offered to a limited number
                of outside clients.
              </p>
            </div>
          </div>
        </div>
      </section>

      <ContactStrip
        email="properties@penlandllc.com"
        title="Property questions?"
        description="For anything related to the properties we manage, reach out to Penland Properties."
      />
      <SiteFooter />
    </main>
  );
}